<template>
  <div class="bot">
    <div class="content">
      <div class="kb-list">
        <!--KB-->
        <!-- 
        <div v-if="kbList.first">
          <div class="kb fisrt">
            <a class="kb-link" :href="kbList.first.Url" target="_blank">{{
              kbList.first.Title
            }}</a>
            <a :href="kbList.first.Url" target="_blank" class="kb-summary">
              <div class="summary">
                {{ kbList.first.Summary.slice(0, 250) }}
                <span v-if="kbList.first.Summary.length > 250">...</span>
              </div>
            </a>
          </div>
          <div class="kb others">
            <p>{{ $t("GPT.LAYOUT.READMORE") }}</p>
            <a
              class="kb-link"
              :href="kb.Url"
              target="_blank"
              v-for="(kb, index) in kbList.others"
              :key="index"
              >{{ kb.Title }}</a
            >
          </div>
        </div> -->
        <!--Rag-->
        <div :ref="message.id"></div>
        <!--滿意度-->
        <div class="options" v-if="typingCompleted">
          <!-- <div class="more" @click="showAll = !showAll">
            {{ showAll ? $t("GPT.LAYOUT.COLLAPSE") : $t("GPT.LAYOUT.READMORE") }}
          </div> -->
          <div>
            <i class="el-icon-loading" v-if="loading"></i>
            <div class="isLike" v-else>
              <div
                class="btn like"
                :class="{
                  active: message.isLike === true,
                  disabled: isFinished,
                }"
                @click="beforeChatLike(true)"
              >
                <i class="bx bx-like"></i>
              </div>
              <div
                class="btn dislike"
                :class="{
                  active: message.isLike === false,
                  disabled: isFinished,
                }"
                @click="beforeChatLike(false)"
              >
                <i class="bx bx-dislike"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="time">
      <span v-show="typingCompleted"> {{ message.createAt | localTime }}</span>
    </div>
  </div>
</template>

<script>
import Typed from "typed.js";
export default {
  name: "gpt-message-bot",
  props: {
    message: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      showAll: false,
      typingCompleted: false,
    };
  },
  created() {
    this.$bus.$on("updateIsLike", () => {
      this.loading = true;
      this.loading = false;
    });
  },
  mounted() {
    const vm = this;

    window.clickQuestion = async function (q, index) {
      if (vm.isFinished) {
        return;
      }
      // GA4 文字連結點擊
      window.dataLayer.push({
        event: "data_layer_event",
        chatbot_session_id: vm.chatbot_session_id,
        event_name_ga4: "text_click_link_genio",
        event_category_DL: "genio",
        event_action_DL: "clicked",
        event_label_DL: `${q}/click_text_link`,
      });

      let question = RAG.relativeQuestions[index];
      let data1 = {
        type: "Text",
        content: q,
        chatUserRole: "customer",
        isHint: true,
      };
      let data2 = {
        type: "System",
        content: JSON.stringify(question),
        chatUserRole: "ChatBot",
      };
      // AP-6871 1+3 你可能也會詢問邏輯調整
      // 使用 type:"System", chatUserRole: "ChatBot"
      await vm.$store.dispatch("gpt/createMessage", data1);
      await vm.$store.dispatch("gpt/createMessage", data2);
    };

    window.clickLink = function (q) {
      // GA4 文字連結點擊
      window.dataLayer.push({
        event: "data_layer_event",
        chatbot_session_id: vm.chatbot_session_id,
        event_name_ga4: "text_click_link_genio",
        event_category_DL: "genio",
        event_action_DL: "clicked",
        event_label_DL: `${q}/click_text_link`,
      });
    };

    function getOthers(type = "rag", questions) {
      function getrelative(questions) {
        let string = "";
        if (type === "rag") {
          questions.forEach((q, index) => {
            string += `<div class="kb-link ${
              vm.isFinished ? "disabled" : ""
            }" data-question="${q.question}" onclick="clickQuestion('${
              q.question
            }',${index})">${q.question}</div>`;
            // GA4 顯示 文字連結按鈕
            window.dataLayer.push({
              event: "data_layer_event",
              chatbot_session_id: vm.chatbot_session_id,
              event_name_ga4: "text_link_impression_genio",
              event_category_DL: "genio",
              event_action_DL: "displayed",
              event_label_DL: `${q.question}/text_link_impression`,
            });
          });
        } else {
          questions.forEach((q) => {
            string += `<a class="kb-link" href="${q.Url}" target="_blank" onclick="clickLink('${q.Title}')">${q.Title}</a>`;
            // GA4 顯示 文字連結按鈕
            window.dataLayer.push({
              event: "data_layer_event",
              chatbot_session_id: vm.chatbot_session_id,
              event_name_ga4: "text_link_impression_genio",
              event_category_DL: "genio",
              event_action_DL: "displayed",
              event_label_DL: `${q.Title}/text_link_impression`,
            });
          });
        }

        return string;
      }
      if (questions.length) {
        return `
        <div class="kb others" id="others">
          <div class="kb-link-container">
            <p>${vm.$t("GPT.LAYOUT.YOU_MAY_ALSO")}</p>
            ${getrelative(questions)}
          </div>
        </div>`;
      } else {
        return "";
      }
    }

    let el;
    // #1 RAG
    let RAG = this.rag; // ragResponse (RAG)
    // #2 HINT
    let HINT = this.rag?.relativeQuestions; // relativeQuestions (HINT)
    // #3 KbList
    let KbList = this.kbList;

    if (RAG && HINT.length) {
      // #1 ragResponse +  ragContent + relativeQuestions
      el = `
      <div> 
        <div class="kb first">${RAG.ragResponse}<br />
          ${vm.$t("GPT.LAYOUT.FOR_FURTHER")}
          <a href="${
            RAG.ragContentLink
          }" target="_blank" class="kb-link" onclick="clickLink('${
        RAG.ragContentTitle
      }')">${RAG.ragContentTitle}</a></div>
        ${getOthers("rag", RAG.relativeQuestions)}
      </div>`;
    } else if (RAG && KbList) {
      // #2 ragResponse + KbList no Hint
      el = `
      <div> 
        <div class="kb first">${RAG.ragResponse}<br />
          ${vm.$t("GPT.LAYOUT.FOR_FURTHER")}
          <a href="${
            RAG.ragContentLink
          }" target="_blank" class="kb-link" onclick="clickLink('${
        RAG.ragContentTitle
      }')">${RAG.ragContentTitle}</a></div>${getOthers(
        "kb",
        KbList.others
      )}</div>`;
    } else if (KbList.others.length) {
      // #3 only KbList
      el = `
      <div> 
        <div class="kb first">${KbList.first.Summary}<br />
          ${vm.$t("GPT.LAYOUT.FOR_FURTHER")}
          <a href="${
            KbList.first.Url
          }" target="_blank" class="kb-link" onclick="clickLink('${
        KbList.first.Title
      }')">${KbList.first.Title}</a></div>${getOthers(
        "kb",
        KbList.others
      )}</div>`;
    } else if (RAG && RAG.ragResponse) {
      // #4 only RAG
      el = `
      <div> 
        <div class="kb first">${RAG.ragResponse}<br />
        ${vm.$t("GPT.LAYOUT.FOR_FURTHER")}
        <a href="${
          RAG.ragContentLink
        }" target="_blank" class="kb-link" onclick="clickLink('${
        RAG.ragContentTitle
      }')">${RAG.ragContentTitle}</a>`;
    }
    // GA4
    if (RAG || KbList.first) {
      window.dataLayer.push({
        event: "data_layer_event",
        chatbot_session_id: this.chatbot_session_id,
        event_name_ga4: "text_link_impression_genio",
        event_category_DL: "genio",
        event_action_DL: "displayed",
        event_label_DL: `${
          RAG?.ragContentTitle || KbList.first?.Title
        }/text_link_impression`,
      });
    }
    // 1.檢查是否已經完成打字效果
    if (this.checkTyped(this.message.id)) {
      this.$refs[this.message.id].insertAdjacentHTML("beforeend", el);
      this.typingCompleted = true;
    } else {
      if (el) {
        this.startTying(el);
      }
    }
  },
  methods: {
    startTying(el) {
      const vm = this;
      const sanitizedEl = el.replace(/&(?!\w+;)/g, "&amp;");
      new Typed(this.$refs[this.message.id], {
        strings: [sanitizedEl],
        showCursor: false,
        typeSpeed: 5,
        loop: false,
        onComplete: function () {
          vm.setTyped(vm.message.id);
          vm.typingCompleted = true;
          vm.$store.dispatch("gpt/createBotReplyMessage", "ChatGPT_BotReply");
        },
      });
    },
    checkTyped(id) {
      let data = localStorage.getItem("asus_chat_gpt_typed") || [];
      return data.includes(id);
    },
    setTyped(id) {
      let data = JSON.parse(localStorage.getItem("asus_chat_gpt_typed")) || [];
      data.push(id);
      localStorage.setItem("asus_chat_gpt_typed", JSON.stringify(data));
    },
    beforeChatLike(val) {
      if (this.isFinished) {
        return;
      }
      if (val) {
        // like
        this.handleChatLike(true);
      } else {
        // dislike
        if (this.ChatGPT_IsShow_DislikeReason) {
          // 顯示滿意度選項 "0" / "1"
          this.$bus.$emit("openBotSurvey", this.message.id);
        } else {
          this.handleChatLike(false);
        }
      }
    },
    async handleChatLike(val) {
      this.loading = true;
      try {
        await this.$store.dispatch("gpt/handleChatLike", {
          chatBotMessageId: this.message.id,
          likeFlag: val,
          surveyCode: "",
        });
        // GA4 按讚
        window.dataLayer.push({
          event: "data_layer_event",
          chatbot_session_id: this.chatbot_session_id,
          event_name_ga4: val ? "like_genio" : "dislike_genio",
          event_category_DL: "genio",
          event_action_DL: "clicked",
          event_label_DL: val ? "like" : "dislike",
        });
      } catch (error) {
        console.log("error", error);
      }
      this.loading = false;
    },
    async submit(q) {
      let data = { type: "Text", content: q, chatUserRole: "customer" };
      this.$store.commit("gpt/saveUserInput", q);
      await this.$store.dispatch("gpt/createMessage", data);
      await this.$store.dispatch("gpt/createChatRenderMessage");
    },
  },
  computed: {
    status() {
      return JSON.parse(this.message.content).Status;
    },
    kbList() {
      const result = JSON.parse(this.message.content).Result;
      const first = result ? result.KbList.shift() : null; // 第一則
      const others = result ? result.KbList : [];
      return {
        first,
        others,
      };
    },
    rag() {
      const result = JSON.parse(this.message.content).Result;

      if (result) {
        const returnMessage = () => {
          try {
            return JSON.parse(result.ReturnMessage);
          } catch (e) {
            return result.ReturnMessage;
          }
        };
        if (typeof returnMessage() === "object") {
          return returnMessage();
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    chatbot_session_id() {
      return this.$store.getters["gpt/chatbot_session_id"];
    },
    ChatGPT_IsShow_DislikeReason() {
      return this.$store.state.gpt.setting.ChatGPT_IsShow_DislikeReason === "1";
    },
    isFinished() {
      return this.$store.state.gpt.botRoom.isFinished;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "gpt.scss";
</style>
